import { render, staticRenderFns } from "./CovidHistoryCheckIn.vue?vue&type=template&id=0c69124a&scoped=true&"
import script from "./CovidHistoryCheckIn.vue?vue&type=script&lang=js&"
export * from "./CovidHistoryCheckIn.vue?vue&type=script&lang=js&"
import style0 from "./CovidHistoryCheckIn.vue?vue&type=style&index=0&id=0c69124a&lang=scss&scoped=true&"
import style1 from "./CovidHistoryCheckIn.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c69124a",
  null
  
)

export default component.exports